import $ from 'jquery';

let mobileMenuBreakpoint = 0
const $win = $(window);
const $body = $('body');
const $coupon_tooltip = $('.coupon-tooltip')
let $coupon_mobile = $('.coupon-mobile')
const $coupon_mobile_original_text = $coupon_mobile.text()
if ($body.hasClass('dealer')) {
    mobileMenuBreakpoint = 1704
} else {
    mobileMenuBreakpoint = 1524
}

const $header = $('.site-header-wrap');
const $headerMenu = $('.site-header .site-header__menu');
const $headerNav = $('.site-header .site-header__nav');

function NavigateMobileSubMenu(level, $subMenu) {
    $subMenu = $subMenu || null;
    if($subMenu) {
        $subMenu.addClass('active');
    }
    $headerMenu.css('transform', 'translate(' + (-100 * level) + '%)');
    $headerNav.attr('data-currentlevel', level);
}

$('.site-header .sub-menu-back').click(function () {
    const $parentLi = $(this).closest('li.nav-column');
    const level = $(this).attr('data-backlevel');
    if ($parentLi.length) {
        const newLevel = parseInt(level) - 1;
        NavigateMobileSubMenu(newLevel);
    } else {
        NavigateMobileSubMenu(level);
    }
});

$('.site-header .menu-item-has-children').each(function (){
    const $self = $(this);
    const $link = $self.find('> a');
    const $subMenu = $self.find('> .sub-menu');
    const $subMenuBack = $subMenu.find('> .sub-menu__back');
    const $navColumn = $self.parent().parent().hasClass('nav-column')

    const linkHref = $link.attr('href');

    if(linkHref !== '#' && linkHref !== '' && linkHref !== undefined) {
        const $menuItemDuplicate = $('<li class="menu-item menu-item--duplicate"></li>');
        $link.clone().appendTo($menuItemDuplicate);
        $subMenuBack.after($menuItemDuplicate);
    }

    $link.click(function(event) {
        let $subMenuLevel = $subMenu.attr('data-depth');
        if ($win.width() <= mobileMenuBreakpoint) {
            event.preventDefault();
            $headerMenu.find('.sub-menu[data-depth=' + $subMenuLevel + ']').removeClass('active');
            if ($subMenuLevel === '2') {
                $headerMenu.find('.sub-menu[data-depth=' + (parseInt($subMenuLevel) + 1) + ']').removeClass('active');
            }
            if ($navColumn) {
                let navColumnDataDepth = $subMenu.attr('data-depth') - 1;
                NavigateMobileSubMenu(navColumnDataDepth, $subMenu);
            } else {
                NavigateMobileSubMenu($subMenuLevel, $subMenu);
            }
        }
    });
});

$('.mobile-close, .mobile-menu-toggle').click(function () {
    $headerNav.toggleClass('open');
    $(this).toggleClass('is-active');
});

$('.mobile-menu-toggle').on('click', () => {
    const $headerNavOpen = $('.hamburger.is-active');
    if ($headerNavOpen.length !== 0) {
        $header.css('position', 'fixed')
        $('#main').addClass('fixed-nav')
    } else {
        $header.css('position', 'relative')
        $('#main').removeClass('fixed-nav')
    }
})

// Add header height as css var.
function setMenuHeightVar() {
    $body.css('--header-height', $header.height() + 'px');
}

// Do this on page load
setMenuHeightVar();

// Do this on resize
window.addEventListener('resize', event => {
    setMenuHeightVar();
    $('.site-header-wrap').css('position', 'relative')
});

$('.coupon-callout').on('click', (e) => {
    const $this = $(e.currentTarget)
    let $text = $this.attr('data-text')
    navigator.clipboard.writeText($text).then(function() {
        if($(window).innerWidth() > 480) {
            $coupon_tooltip.addClass('show-tooltip');
            setTimeout(function() {
                $coupon_tooltip.removeClass("show-tooltip");
            }, 3000);
        } else {
            $coupon_mobile.text('Copied!')
            setTimeout(function() {
                $coupon_mobile.text($coupon_mobile_original_text);
            }, 3000);
        }


    } )
})
